import { Button } from '@/components/ui/button';
import { ConfirmDialog } from '@/components/feature/confirm-dialog';
import { FileData } from '@/types/file';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';

interface FileGridItemActionsProps {
  file: FileData;
  onDelete: (file: FileData) => Promise<void>;
}

export function FileGridItemActions({ file, onDelete }: FileGridItemActionsProps) {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await onDelete(file);
      setShowDeleteConfirm(false);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <Button
        variant="secondary"
        size="icon"
        className="h-8 w-8"
        onClick={() => setShowDeleteConfirm(true)}
      >
        <Trash2 className="h-4 w-4" />
      </Button>

      <ConfirmDialog
        open={showDeleteConfirm}
        onOpenChange={setShowDeleteConfirm}
        title="Delete File"
        description={`Are you sure you want to delete "${file.name}"? This action cannot be undone.`}
        confirmText="Delete"
        confirmVariant="destructive"
        onConfirm={handleDelete}
        isLoading={isDeleting}
      />
    </>
  );
}
